"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataAndAriaProperties = void 0;
var getDataAndAriaProperties = function (base) {
    var copy = {};
    Object.entries(base).map(function (value) {
        if (value[0].startsWith('data-') || value[0].startsWith('aria-')) {
            copy[value[0]] = value[1];
        }
    });
    return copy;
};
exports.getDataAndAriaProperties = getDataAndAriaProperties;
